import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchToursDetailsAfterBooking } from "../../api/toursDetailsApi";
// import { fetchToursDetails } from "../../../lib/service/tours/api"; // Adjust the path as necessary

// Async thunk for fetching tour details
export const fetchToursDetailsAfterBookingThunk = createAsyncThunk(
  "toursDetails/fetchToursDetailsAfterBooking",
  async ({ products_id }, { rejectWithValue }) => {
    try {
      const response = await fetchToursDetailsAfterBooking({ products_id });

      return response.data; // Assuming the API response has a `data` property
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  details: null, // Tour details
  loading: false,
  error: null,
};

// Slice
const toursDetailsAfterBookingSlice = createSlice({
  name: "toursDetailsAfterBooking",
  initialState,
  reducers: {
    clearDetails(state) {
      state.details = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchToursDetailsAfterBookingThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchToursDetailsAfterBookingThunk.fulfilled,
        (state, action) => {
          state.loading = false;
          state.details = action.payload;
        }
      )
      .addCase(fetchToursDetailsAfterBookingThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearDetails } = toursDetailsAfterBookingSlice.actions;
export default toursDetailsAfterBookingSlice.reducer;
